import React from "react";
import s from "./Footer.module.css"
import ContactsFooter from "./Contatcs/ContactsFooter";


const Footer = () => {
    return (
        <div className={s.footer}>
            <ContactsFooter/>
        </div>
    )
};

export default Footer;